import { useAppState } from '../state/AppState';
import styles from './Header.module.css';

export function Header() {
  const { state, setView } = useAppState();
  const view = state.view.kind;

  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <div className={styles.logo}>
          <span className={styles.logoMain}>Halcyon</span>{' '}
          <span className={styles.logoTail}>Capital Partners</span>
          <div className={styles.subtitle}>SENTINEL Onboarding</div>
        </div>
      </div>

      <nav className={styles.nav} aria-label="Primary">
        <button
          type="button"
          className={view === 'list' ? styles.navActive : styles.navBtn}
          onClick={() => setView({ kind: 'list' })}
          aria-current={view === 'list' ? 'page' : undefined}
        >
          Audit list
        </button>
        <button
          type="button"
          className={view === 'intake' ? styles.navActivePrimary : styles.navBtnPrimary}
          onClick={() => setView({ kind: 'intake' })}
          aria-current={view === 'intake' ? 'page' : undefined}
        >
          + New assessment
        </button>
      </nav>

      <div className={styles.rm}>
        <div className={styles.rmLabel}>Signed in as</div>
        <div className={styles.rmName}>{state.currentRm}</div>
      </div>
    </header>
  );
}
